import Choices from 'choices.js';
import flatpickr from "flatpickr";
import Inputmask from "inputmask";

$().ready(function () {
//date picker
const dateSelector = document.querySelectorAll('.js-flatpickr'),
    simpleDateSelector = document.querySelectorAll('.datepicker'),
    months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const datePickerWithMaskInput = () => {
    Array.prototype.forEach.call(dateSelector, (el) => {

        let maskedInput = el.querySelector('.js-flatpickr--masked'),
            flatPickrInput = el.querySelector('.js-flatpickr--picker'),
            isMembershipForm = el.classList.contains('is-membership-form'),
            pickerToggle = el.querySelector('.form-date-picker__toggle'),
            isClickOnPickerToggle = false;

        const showFlatPickrInput = () => {
            flatPickrInput.classList.remove('hide');
            maskedInput.classList.remove('show');
        }

        const formatMaskedInput = (date) => {
            let formattedDate = date.split('/').join(' '),
                mm = formattedDate.slice(3, 5),
                index = parseInt(mm) - 1,
                formattedMonth = months[index];

            return formattedDate.slice(0, 2) + ' ' + formattedMonth + ' ' + formattedDate.slice(6, 10);
        }

        const formatFlatInput = (date) => {
            let mm = date.length == 10 ? date.slice(2, 5) : date.slice(3, 6),
                index = months.indexOf(mm),
                monthInt = parseInt(index) + 1,
                formattedMonth = monthInt < 10 ? '0' + monthInt : monthInt;

            if (date.length == 10)
                return '0' + date.slice(0, 1) + '/' + formattedMonth + '/' + date.slice(6, 10);
            else
                return date.slice(0, 2) + '/' + formattedMonth + '/' + date.slice(7, 11);
        }

        const isValidMaskedInput = (value) => {
            if (value.indexOf('d') > -1)
                return false;

            if (value.indexOf('m') > -1)
                return false;

            if (value.indexOf('y') > -1)
                return false;

            if (value == '')
                return false;

            return true;
        };

        //init mask on the secondary input
        Inputmask({ alias: "datetime", inputFormat: "dd/mm/yyyy" }).mask(maskedInput);

        //if user types all the required digits, the input is formatted and the primary input is shown
        maskedInput.addEventListener('blur', function() {
            let currentValue = this.value;

            if (!isValidMaskedInput(currentValue)) {
                showFlatPickrInput();
                return false;
            }

            let date = formatMaskedInput(currentValue);
            flatPickrInput.value = date;
            flatPickrInput.classList.add('selected');

            if (isMembershipForm)
                el.classList.remove('empty');

            showFlatPickrInput();
        });

        maskedInput.addEventListener('focus', function() {
            if (isMembershipForm)
                el.classList.remove('empty');
        });

        flatpickr(el, {
            dateFormat: "j M Y",
            disableMobile: true,
            wrap: true,
            onReady: function(selectedDates, dateStr, instance) {

                pickerToggle.addEventListener('click', function() {
                    isClickOnPickerToggle = true;
                });

                flatPickrInput.addEventListener('focus', function(event) {
                    const eventKeydown = new Event('ondblclick');

                    instance.close();

                    this.classList.add('hide')
                    maskedInput.classList.add('show');
                    maskedInput.dispatchEvent(eventKeydown);
                });
            },
            onChange: function(selectedDates, dateStr, instance) {
                flatPickrInput.classList.add('selected');
                maskedInput.value = formatFlatInput(dateStr);
                if (isClickOnPickerToggle) {
                    showFlatPickrInput();
                    isClickOnPickerToggle = false;
                }
                maskedInput.classList.add('show');
            },
            onOpen: function(selectedDates, dateStr, instance) {
                el.parentElement.classList.add('opened')
            },
            onClose: function(selectedDates, dateStr, instance) {
                el.parentElement.classList.remove('opened');
            }
        });

    });
}

datePickerWithMaskInput();

const simpleDatePicker = () => {
    Array.prototype.forEach.call(simpleDateSelector, (el) => {
        flatpickr(el, {
            dateFormat: "j M Y",
            disableMobile: true,

            onChange: function(selectedDates, dateStr, instance) {
                flatPickrInput.classList.add('selected');
            },
            onOpen: function(selectedDates, dateStr, instance) {
                el.parentElement.classList.add('opened')
            },
            onClose: function(selectedDates, dateStr, instance) {
                el.parentElement.classList.remove('opened');
            }
        })
    });
}
simpleDatePicker();

const formSelect = document.getElementsByClassName('form-select-input');
const formSelectWFFM = document.querySelectorAll('[data-wffm], [data-sc-fxb]');
let choicesApplied = false;
var choices;

if (formSelect.length || formSelectWFFM.length) {

    const customSelectStyle = function() {
        if (window.innerWidth >= 768) {
            if (!choicesApplied) {

                if (document.querySelector('.form-select-input')) {
                    const choices = new Choices('.form-select-input', {
                        searchEnabled: false,
                        shouldSort: false,
                        itemSelectText: ''
                    });
                }

                if ($('select.form-control:not([size])').length) {
                    const choicesWFFM = new Choices('select.form-control:not([size])', {
                        searchEnabled: false,
                        shouldSort: false,
                        itemSelectText: ''
                    });
                }

                const choicesSelectBoxes = document.querySelectorAll('.form-select--float .choices, [data-wffm] .choices, [data-sc-fxb] .choices');
                Array.prototype.forEach.call(choicesSelectBoxes, (el) => {
                    el.parentElement.classList.add('choices-form-select');
                    const selectEl = el.querySelector('.choices__input');

                    const applySelected = () => {
                        if (selectEl.value === null || selectEl.value === '') {
                            el.classList.remove('selected');
                            el.parentElement.classList.remove('selected');
                        } else {
                            el.classList.add('selected');
                            el.parentElement.classList.add('selected');
                        }
                    }

                    applySelected();

                    selectEl.addEventListener('change', () => {
                        applySelected();
                    })
                })
                choicesApplied = true;
            }
        } else {
          function setSelectedClass() {
            const selectBoxes = document.querySelectorAll('.form-select--float, .form-select--float .choices, [data-wffm] .choices, [data-sc-fxb] .choices');
            if (!choicesApplied) {
              if ($('select.form-control:not([size])').length) {
                const choicesWFFM = new Choices('select.form-control:not([size])', {
                  searchEnabled: false,
                  shouldSort: false,
                  itemSelectText: ''
                });
              }
              choicesApplied = true;
            }
            Array.prototype.forEach.call(selectBoxes, (el) => {
              el.parentElement.classList.add('choices-form-select');

              let selectEl = el.querySelector('.form-select-input');
              selectEl !== null ?
                selectEl.addEventListener('change', () => {
                  if (selectEl.value === null || selectEl.value === '') {
                    el.classList.remove('selected');
                  } else {
                    el.classList.add('selected');
                  }
                })
                : null;

              selectEl = el.querySelector('.choices__input');
              selectEl !== null ?
                selectEl.addEventListener('change', () => {
                  if (selectEl.value === null || selectEl.value === '') {
                    el.classList.remove('selected');
                    el.parentElement.classList.remove('selected');
                  } else {
                    el.classList.add('selected');
                    el.parentElement.classList.add('selected');
                  }
                })
                : null;
            })
          }
          setSelectedClass();
          setTimeout(function () { setSelectedClass()}, 500)
        }
    }
    customSelectStyle();
    $(window).smartresize(() => {
        customSelectStyle();
    })
}




// Floating Label select
const selectFloatingLabelElements = document.querySelectorAll('.js-form-select.form-select-floating-label');
if (selectFloatingLabelElements.length) {
    Array.prototype.forEach.call(selectFloatingLabelElements, (el) => {
        const selectEl = el.querySelector('.form-select-input');
        const childOptions = selectEl.querySelector('option');
        selectEl.addEventListener('focus', () => {
            if (selectEl.value === null || selectEl.value === '') {
                el.classList.add('empty');
            } else {
                el.classList.remove('empty');
            }
        });
        selectEl.addEventListener('keypress', () => {
            if (selectEl.value === null || selectEl.value === '') {
                el.classList.add('empty');
            } else {
                el.classList.remove('empty');
            }
        });

    });
}


// Floating Label inputs
const textfieldFloatingLabelElements = document.querySelectorAll('.js-form-textfield.form-textfield-floating-label');
if (textfieldFloatingLabelElements.length) {
    Array.prototype.forEach.call(textfieldFloatingLabelElements, (el) => {
        const inputEl = el.querySelector('.form-textfield-input');
        if (inputEl.value === null || inputEl.value === '') {
            el.classList.add('empty');
        }
        inputEl.addEventListener('change', () => {
            if (inputEl.value === null || inputEl.value === '') {
                el.classList.add('empty');
            }
        });

    });
}

// Floating Label inputs - WFFM
const textfieldFloatingLabelElementsWFFM = document.querySelectorAll('form[data-wffm] input.form-control, form[data-wffm] textarea.form-control, form[data-sc-fxb] input.form-control, form[data-sc-fxb] textarea.form-control');
if (textfieldFloatingLabelElementsWFFM.length) {
    Array.prototype.forEach.call(textfieldFloatingLabelElementsWFFM, (el) => {
        const inputEl = el;
        let parentEl = inputEl.parentElement;

        if (el.classList.contains('password')) {
            parentEl = inputEl.previousElementSibling;
        }
        if (inputEl.value === null || inputEl.value === '') {
            parentEl.classList.add('empty');
        }
        inputEl.addEventListener('focus', () => {
            parentEl.classList.remove('empty');
        });
        inputEl.addEventListener('keypress', () => {
            parentEl.classList.remove('empty');
        });
        inputEl.addEventListener('blur', () => {
            if (inputEl.value === null || inputEl.value === '') {
                parentEl.classList.add('empty');
            }
        });
    });
}

//upload file type WFFM

const fileUploadWFFM = document.querySelectorAll('form[data-wffm] input[type=file], form[data-sc-fxb] input[type=file]');
if (fileUploadWFFM.length) {
    Array.prototype.forEach.call(fileUploadWFFM, (el) => {
        const inputEl = el;
        const parentEl = inputEl.parentElement;
        parentEl.classList.add('form-file-upload');
    });
}

//text area WFFM

const textareaWFFM = document.querySelectorAll('form[data-wffm] textarea, form[data-sc-fxb] textarea');
if (textareaWFFM.length) {
    Array.prototype.forEach.call(textareaWFFM, (el) => {
        const inputEl = el;
        const parentEl = inputEl.parentElement;
        parentEl.classList.add('form-textarea');
    });
}

//recaptcha
const recaptchaWFFM = document.querySelectorAll('.g-recaptcha');
if (recaptchaWFFM.length) {
    Array.prototype.forEach.call(recaptchaWFFM, (el) => {
        const inputEl = el;
        const parentEl = inputEl.parentElement;
        parentEl.classList.add('form-recaptcha');
    });
}
//password type WFFM

const passwordWFFM = document.querySelectorAll('form[data-wffm] .password, form[data-sc-fxb] .password');
if (passwordWFFM.length) {
    Array.prototype.forEach.call(passwordWFFM, (el) => {
        const inputEl = el;
        const parentEl = inputEl.parentElement;
        parentEl.classList.add('form-password');
    });
}

//list box multiple showing WFFM

const listBoxWFFM = $('form[data-wffm] select[size], form[data-sc-fxb] select[size]');
if (listBoxWFFM.length) {
    listBoxWFFM.each(function(i, el) {
        const inputEl = el;
        const parentEl = inputEl.parentElement;
        parentEl.classList.add('form-list-box');
    })
}

//date WFFM

const dateWFFM = document.querySelectorAll('form[data-wffm] .wfmDatebox, form[data-sc-fxb] .wfmDatebox');
if (dateWFFM.length) {
    Array.prototype.forEach.call(dateWFFM, (el) => {
        const inputEl = el;
        const parentEl = inputEl.parentElement;
        parentEl.classList.add('form-date');
    });
}

const radioLabel = $('.radio label');
const checkboxLabel = $('.checkbox label');

if (radioLabel.length) {
    $('.radio label').each((i, v) => {
        $(v).append('<span></span>');
    });
}

if (checkboxLabel.length) {
    $('.checkbox label').each((i, v) => {
        $(v).append('<span></span>');
    });
}

});

var $recaptchaElement = $('form[data-sc-fxb] .fxt-captcha');
var intervalms = 100;
var executingRecaptcha = false;
var recaptchaVersion = "v2";
var recaptchaSiteKey = "none";

var checkRecaptcha = function () {
    if (executingRecaptcha) { return; }
    if (!window.grecaptcha) { return; }
    var $formElement = $recaptchaElement.closest('form');
    $.validator.unobtrusive.parse($formElement);
    var isFormValid = $formElement.validate().checkForm();
    if (!isFormValid) { return; }

    executingRecaptcha = true;
    window.grecaptcha.ready(function () {
        window.grecaptcha.execute(recaptchaSiteKey, { action: 'submit' }).then(function (token) {
            $recaptchaElement.val(token);

            executingRecaptcha = false;
            intervalms = 119700; //  just under 2minutes
            clearInterval(interval);
            interval = setInterval(checkRecaptcha, intervalms);
        });
    });
}

if ($recaptchaElement.length) {
    recaptchaVersion = $recaptchaElement.attr("data-recaptcha-version");
    recaptchaSiteKey = $recaptchaElement.attr("data-recaptcha-site-key");

    if (recaptchaVersion == "v3") {
        $recaptchaElement.val("a valid field value, but not a valid captcha token");
        var interval = setInterval(checkRecaptcha, intervalms); // check every 100ms
    } else {
        window.reCaptchaArray = window.reCaptchaArray || [];
        window.reCaptchaArray.push(function () {
            window.grecaptcha.render($recaptchaElement.attr('id') + '_wrapper',
                {
                    'sitekey': recaptchaSiteKey,
                    'callback': function (token) {
                        $recaptchaElement.val(token);
                    },
                    'expired-callback': function (args) {
                        $recaptchaElement.val("");
                    }
                });
        });
    }
};

(function ($) {
  var data_click = "unobtrusiveAjaxClick",
    data_target = "unobtrusiveAjaxClickTarget",
    data_validation = "unobtrusiveValidation";

  function getFunction(code, argNames) {
    var fn = window, parts = (code || "").split(".");
    while (fn && parts.length) {
      fn = fn[parts.shift()];
    }
    if (typeof (fn) === "function") {
      return fn;
    }
    argNames.push(code);
    return Function.constructor.apply(null, argNames);
  }

  function isMethodProxySafe(method) {
    return method === "GET" || method === "POST";
  }

  function asyncOnBeforeSend(xhr, method) {
    if (!isMethodProxySafe(method)) {
      xhr.setRequestHeader("X-HTTP-Method-Override", method);
    }
  }

  function asyncOnSuccess(element, data, contentType) {
    var mode;

    if (contentType.indexOf("application/x-javascript") !== -1) {// jQuery already executes JavaScript for us
      return;
    }

    mode = (element.getAttribute("data-ajax-mode") || "").toUpperCase();
    $(element.getAttribute("data-ajax-update")).each(function (i, update) {
      var top;

      switch (mode) {
        case "BEFORE":
          $(update).prepend(data);
          break;
        case "AFTER":
          $(update).append(data);
          break;
        case "REPLACE-WITH":
          $(update).replaceWith(data);
          break;
        default:
          $(update).html(data);
          break;
      }
    });
  }

  function asyncRequest(element, options) {
    var confirm, loading, method, duration;

    confirm = element.getAttribute("data-ajax-confirm");
    if (confirm && !window.confirm(confirm)) {
      return;
    }

    loading = $(element.getAttribute("data-ajax-loading"));
    duration = parseInt(element.getAttribute("data-ajax-loading-duration"), 10) || 0;

    $.extend(options, {
      type: element.getAttribute("data-ajax-method") || undefined,
      url: element.getAttribute("data-ajax-url") || undefined,
      cache: (element.getAttribute("data-ajax-cache") || "").toLowerCase() === "true",
      beforeSend: function (xhr) {
        var result;
        asyncOnBeforeSend(xhr, method);
        result = getFunction(element.getAttribute("data-ajax-begin"), ["xhr"]).apply(element, arguments);
        if (result !== false) {
          loading.show(duration);
        }
        return result;
      },
      complete: function () {
        loading.hide(duration);
        getFunction(element.getAttribute("data-ajax-complete"), ["xhr", "status"]).apply(element, arguments);
      },
      success: function (data, status, xhr) {
        asyncOnSuccess(element, data, xhr.getResponseHeader("Content-Type") || "text/html");
        getFunction(element.getAttribute("data-ajax-success"), ["data", "status", "xhr"]).apply(element, arguments);
      },
      error: function () {
        getFunction(element.getAttribute("data-ajax-failure"), ["xhr", "status", "error"]).apply(element, arguments);
      }
    });

    method = options.type.toUpperCase();
    if (options.data instanceof FormData) {
      options.processData = false;
      options.contentType = false;
      options.data.append("X-Requested-With", "XMLHttpRequest");

      if (!isMethodProxySafe(method)) {
        options.type = "POST";
        options.data.append("X-HTTP-Method-Override", method);
      }
    } else {
      options.data.push({ name: "X-Requested-With", value: "XMLHttpRequest" });

      if (!isMethodProxySafe(method)) {
        options.type = "POST";
        options.data.push({ name: "X-HTTP-Method-Override", value: method });
      }
    }

    $.ajax(options);
  }

  function validate(form) {
    var validationInfo = $(form).data(data_validation);
    return !validationInfo || !validationInfo.validate || validationInfo.validate();
  }

  $(document).off("submit", "form[data-ajax=true]").on("submit", "form[data-ajax=true]", function (evt) {
    var clickInfo = $(this).data(data_click) || [],
      clickTarget = $(this).data(data_target),
      isCancel = clickTarget && (clickTarget.hasClass("cancel") || clickTarget.attr('formnovalidate') !== undefined);
    evt.preventDefault();
    if (!isCancel && !validate(this)) {
      return;
    }
    var formData;
    if (this.enctype && this.enctype === "multipart/form-data") {
      var formClone = $(this);
      var buttonInfo = [];
      for (var i = 0; i < clickInfo.length; i++) {
        var origClickInfo = $(formClone).find("#" + clickInfo[i].name.replace(/\./g, "_"));
        buttonInfo.push({ name: clickInfo[i].name, value: clickInfo[i].value });
        if (origClickInfo.length > 0) {
          buttonInfo.push({ name: clickInfo[i].name, value: $(origClickInfo)[0].value });
          $(origClickInfo).remove();
        }
      }
      formData = new FormData(formClone[0]);
      for (var i = 0; i < buttonInfo.length; i++) {
        if (formData.has(buttonInfo[i].name) && formData.get(buttonInfo[i].name) === buttonInfo[i].value) {
          formData.delete(buttonInfo[i].name);
        }
        formData.append(buttonInfo[i].name, buttonInfo[i].value);
      }
    } else {
      formData = clickInfo.concat($(this).serializeArray());
    }

    asyncRequest(this, {
      url: this.action,
      type: this.method || "GET",
      data: formData
    });
  });
}(jQuery));
